import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

import './NavItem.scss'

import IconButton from '../../Common/Buttons/IconButton/IconButton'
import Tooltip from '../../Tooltip/Tooltip'

const NavItem = withRouter((props) => {
  const {
    to,
    location,
    imageSrc,
    children,
    id,
    translationKeyTooltip,
    onClick: onNavItemClick,
  } = props

  const onClick = useCallback((e) => {
    if (!imageSrc || onNavItemClick) {
      e.preventDefault()
    }

    onNavItemClick && onNavItemClick(e)
  }, [imageSrc, onNavItemClick])

  const LinkComponent = onNavItemClick ? 'span' : Link

  return (
    <LinkComponent
      to={to}
      className={'nav-item'}
      onClick={onClick}
      id={id}
    >
      <Tooltip
        translationKey={translationKeyTooltip}
        placement='right'
      > 
        <IconButton
          size="big"
          component="span"
          disabled={!imageSrc}
          active={location.pathname === to}
        >
          {children}
        </IconButton>
      </Tooltip>
    </LinkComponent>
    
  )
})

const mapStateToProps = ({ 
  imageStore: { 
    imageSrc 
  }, 
}) => ({
  imageSrc,
})

export default connect(
  mapStateToProps
)(NavItem)
